/**
 * S2 — the long-wait countdown format, old ref `formattedTimeInDays()`
 * (`@/Utils/CommonUtils`): `d h m s` over a day (e.g. `1d 4h 20m 10s`),
 * `h m s` over an hour, `m:ss` under an hour. Pure, so the status card's
 * ticking is testable without a clock.
 */
export const formatCountdown = (totalSeconds: number): string => {
  const secs = Math.max(0, Math.floor(totalSeconds));
  const days = Math.floor(secs / 86400);
  const hours = Math.floor((secs % 86400) / 3600);
  const minutes = Math.floor((secs % 3600) / 60);
  const seconds = secs % 60;

  if (days > 0) {
    return `${days}d ${hours}h ${minutes}m ${seconds}s`;
  }
  if (hours > 0) {
    return `${hours}h ${minutes}m ${seconds}s`;
  }
  return `${minutes}:${String(seconds).padStart(2, '0')}`;
};

export default formatCountdown;
